import React, { Component } from "react";
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { Grid, GridColumn as Column, GridToolbar } from '@progress/kendo-react-grid';
import '@progress/kendo-theme-material/dist/all.css';
import { filterBy } from '@progress/kendo-data-query';

const API = 'https://api.airtable.com/v0/appNEvdffD81GW0Il/';
const TABLE = 'Characters';
const KEY = 'key8HjQynSmGVYIb2';
const INITIALSORT = '&sort[0][field]=Show Name&sort[1][field]=LastName';

const styles = theme => ({
  stubbed: {

  }
});

let userDataStore = [];

class DataEntry extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      error: null,
      userData: this.handleData(undefined),
      filter: undefined,
      editID: null
    };

    this.filterChange = this.filterChange.bind(this);
  }

  filterChange(event) {
    this.setState({
      userData: this.handleData(event.filter),
      filter: event.filter
    });
  }

  handleData(filter) {
    const data = userDataStore.slice();
    return filterBy(data, filter);
  }

  rowClick = (e) => {
    this.setState({
      editID: e.dataItem.ID
    });
  };

  itemChange = (e) => {
    const data = userDataStore.slice();
    const index = data.findIndex(d => d.ID === e.dataItem.ID);
    data[index] = { ...data[index], [e.field]: e.value };
    userDataStore = data;
    this.setState({
      userData: userDataStore
    });
  };

  addRecord = () => {
    /*
    const newRecord = { ProductID: this.state.data.length + 1 };
    const data = this.state.data.slice();
    data.unshift(newRecord);
    this.setState({
      data: data,
      editID: newRecord.ProductID
    });
    */
  };

  closeEdit = (e) => {
    if (e.target === e.currentTarget) {
      this.setState({ editID: null });
    }
  };

  getMeSomeData() {
    this.setState({ isLoading: true });

    fetch(API + TABLE + '?api_key=' + KEY + INITIALSORT)
      .then(response => {
        if (response.ok) {
          return response.json();
        } else {
          throw new Error('Something unexpected has happened!');
        }
      })
      .then(data => {
        // Alter the returned data to a more flat, usable structure for the Keno Grid...
        data.records.map(obj => userDataStore.push(obj.fields)); 
        this.setState({ userData: this.handleData(undefined), isLoading: false });
      })
      .catch(error => this.setState({ error, isLoading: false }));
  }

  componentDidMount() {
    this.getMeSomeData();
  }

  render() {
    const { classes } = this.props;

    if (this.state.error) {
      return (
        <div>
          <h4>Data Entry</h4>
          <p>{this.state.error.message}</p>
        </div>
      );
    }

    if (this.state.isLoading) {
      return (
        <div>
          <h4>Data Entry</h4>
          <p>...Loading...</p>
        </div>
      );
    }

    return (
      <div>
        <h4>Data Entry</h4>
        <p>Showcasing some basic Grid operations using the Kendo UI Grid. Currently fetch, filter and inline editing enabled. While the data is being fetched real time from a remote datasource ( AirTable ), the editing is only locally altered and doesn't persist at this time. The add feature is disabled at this time and you can click in the toolbar area to deselect the inline edit.</p>
        <div>
          <Grid
            style={{ height: '300px' }}
            data={this.state.userData.map((item) =>
              Object.assign({
                inEdit: item.ID === this.state.editID
              }, item)
            )}
            editField="inEdit"
            onRowClick={this.rowClick}
            onItemChange={this.itemChange}
            filterable={true}
            filter={this.state.filter}
            onFilterChange={this.filterChange}
          >
            <GridToolbar>
              <div onClick={this.closeEdit}>
                <button title="Add" onClick={this.addRecord}>Add Character</button>
              </div>
            </GridToolbar >
            <Column field="Show Name String" title="Show" editable={false} />
            <Column field="LastName" title="Last name" />
            <Column field="FirstName" title="First Name" />
          </Grid>
        </div>
        <p>&nbsp;</p>
      </div>
    );
  }
}

DataEntry.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(DataEntry);


// WEBPACK FOOTER //
// ./src/components/DataEntry.js